import React, {useEffect, useRef} from "react";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { ProductTile } from "../../../ecommerce/Product/ProductTile";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import ListProductsCTA from "../ListProductsCTA/ListProductsCTA";
import CarouselNavigation from "@arctheme-components/blocks/NavigationElements/CarouselNavigation";

export default function ListProductsDefault({ products, settings, carousel_item_type = 'carousel-item' }) {
    const { section, mobile_breakpoint, globals } = settings;
    const isMobile = useMobileBreakpoint(mobile_breakpoint);
    const hasInit = useRef(false);

    settings.show_price = section.product_tile_price_show;
    settings.show_quickadd = section.product_tile_quickadd_show;
    settings.show_tags = section.product_tile_tag_show;

    settings.show_indicators = section.show_indicators;
    settings.show_navbuttons = section.show_navbuttons;
    settings.use_freescroll = section.use_freescroll;
    settings.fade_edgeitems = section.fade_edgeitems;

    let ctaPosition = "top";
    const carouselListRef = useRef(null);

    if (isMobile) {
        ctaPosition = "bottom";
    }

    useEffect(() => {
        const handleScroll = () => {
            // if (hasInit.current) return;

            const carousel = document.querySelector(`.carousel-products-list_${settings.section_id}`);
            const flktyCarousel = Flickity.data(carousel);
            var flkty = new Flickity(carousel, {
                ...flktyCarousel.options,
            });
            
            flkty.resize();

            // hasInit.current = true;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    if (products.length <= 0){
        return null;
    }


    return (
        <div className="product-list default-list">
            <div className={"section-top"}>
                <div className={"section-bar w-full flex flex-row justify-between"}>
                    <div className={"section-info"}>
                        <Headings text={section?.title} type={isMobile ? section?.header_style_mobile : section?.header_style} />
                        <Paragraph text={section?.subtext} type={section?.subtext_style} />
                    </div>
                    {ctaPosition === "top" && (
                        <ListProductsCTA section={section} isMobile={isMobile} />
                    )}
                </div>
            </div>

            <div className={"products-list-carousel w-full"}>
                <div
                    className={`carousel carousel-products-list_${settings.section_id}`}
                    data-flickity={`{` +
                        `"freeScroll": ${settings.use_freescroll}, ` +
                        `"wrapAround": true, ` +
                        `"cellAlign": "left", ` +
                        `"pageDots": ${settings.show_indicators}, ` +
                        `"prevNextButtons": ${settings.show_navbuttons}, ` +
                        `"groupCells": 1` +
                        `}`}
                    {...({
                        "x-data": "carousel",
                        "x-init": `$nextTick(() => { initialise(${settings.show_indicators}, ${settings.show_navbuttons}, ${settings.fade_edgeitems}, false, 0, 'multicolumn-carousel', true, ${settings.use_freescroll}) })`,
                        "x-ref": "carousel",
                    })}
                >
                    {products && products.length > 0 && products.map((product, id) => {
                        return (
                            <div key={id} className={`${carousel_item_type}`}>
                                <ProductTile
                                    settings={settings}
                                    product={product}
                                    swatches={product?.swatches}
                                    siblings={undefined}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>

            <div
                className={
                    "section-bottomrow flex flex-row justify-between items-center w-full mt-[12px]"
                }
            >
                <CarouselNavigation
                    shiftPageDots={true}
                    carouselRef={carouselListRef}
                    icons={globals.carousel_icons}
                    size={globals.carousel_icons?.carousel_navigation_arrow_size}
                />
            </div>

            <div className={"section-bottom flex justify-center mt-4"}>
                {ctaPosition === "bottom" && (
                    <ListProductsCTA section={section} isMobile={isMobile} />
                )}
            </div>
        </div>
    );
}
